import { render, staticRenderFns } from "./chartHistogram.vue?vue&type=template&id=23ba37bb"
import script from "./chartHistogram.vue?vue&type=script&lang=js"
export * from "./chartHistogram.vue?vue&type=script&lang=js"
import style0 from "./chartHistogram.vue?vue&type=style&index=0&id=23ba37bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports